module.exports = __webpack_public_path__ + "img/11-1_04.29238517.jpg";